import type { SVGProps } from "react";
// generated from Maximize.svg — do not edit manually
// prettier-ignore
export default function Maximize(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 4 9 V 4 H 9 M 15 4 H 20 V 9 M 20 15 V 20 H 15 M 9 20 H 4 V 15" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
